import { useMemo } from "react";
import { Post } from "store/posts/postConstants";

export const usePostMedia = (post: Post) => {
  return useMemo(() => {
    const postImages = post.media_urls;
    return {
      images: postImages,
      isCarousel: (postImages?.length ?? 0) > 1,
      mediaURL: postImages?.[0],
    };
  }, [post]);
};
